import React, { FunctionComponent, useEffect, useState } from 'react';
import { CloseBasicWhiteNext } from '@tv2/ui-system/icons/next/navigation/CloseBasicWhiteNext';

const Notification: FunctionComponent<{ close: () => void }> = ({ close }) => (
  <div className="deck bg-semantic-warning text-midnight">
    <div className=" py-3  w-col-12 flex justify-between items-start 1440:items-center min-h-[64px]">
      <div className="text-legacy-body-s w-[95%]">
        Det, du er på udkig efter, findes ikke længere på TV 2 Play. Måske kan du finde et
        alternativ her i stedet?
      </div>
      <div
        onClick={close}
        className="flex rounded-full h-8 w-8 1440:h-10 1440:w-10 bg-midnight justify-center items-center cursor-pointer"
      >
        <CloseBasicWhiteNext aria-label="luk" data-testid="close" className="w-5 h-5" />
      </div>
    </div>
  </div>
);

export function ExpiredEntity({ path }: { path: string | undefined }) {
  const [showNotification, setShowNotification] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional dependency management
  useEffect(() => {
    setShowNotification(window.location.hash === '#expired-content');
  }, [path]);

  return showNotification ? (
    <Notification
      close={() => {
        setShowNotification(false);
      }}
    />
  ) : null;
}
